// extracted by css-extract-rspack-plugin
export default {"container":"TrailingBadge-module__container__cBZouMx","label":"TrailingBadge-module__label__ukGYsk5","title":"TrailingBadge-module__title__CTxBerS"};